import React from "react";
import "./styles.scss";
import { ReactComponent as TuneIcon } from "../../../../../public/upload-tune-icon.svg";
import { Link } from "react-router-dom";

export default ({ hide, user }) => {
  return (
    <div
      className="upload-overlay d-flex flex-column justify-content-center align-items-center p-3"
      onClick={hide}
    >
      <TuneIcon className="tune-icon" />
      <p className="title">What are you uploading?</p>
      <div className="options d-flex flex-column">
        <Link to="/upload/single" className="btn btn-primary">
          a single
        </Link>
        <Link to="/upload/albums/new" className="btn btn-primary">
          an album
        </Link>
        {user && user.user_type === "podcaster" && (
          <Link to="/upload/podcast" className="btn btn-primary">
            a podcast
          </Link>
        )}
      </div>
    </div>
  );
};
